export const getDateRangeFromDateArray = dateArray => ({
  from: dateArray[0],
  to: dateArray[dateArray.length - 1],
});
